interface SpinnerProps {
  size?: number;
  className?: string;
}

const Spinner = ({ size = 20, className = "" }: SpinnerProps) => (
  <svg
    className={`animate-spin text-gray-400 ${className}`}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
      className="opacity-25"
    />
    <path
      fill="currentColor"
      className="opacity-75"
      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
    />
  </svg>
);

export default Spinner;
